module.exports = __webpack_public_path__ + "img/slide03bullet03.96c0d09b.png";